import * as _ from "lodash";
import * as log from "loglevel";
import { action, autorun, computed, observable, reaction, runInAction } from "mobx";

export abstract class BaseModel{
	@observable id : string;
	@observable loading = false;
	@observable errorMessage: string = null;

	version : number;
	created : Date;
	updated : Date;

	constructor(data : any = {}) {
		this.fromJSON(data);
	}

	@action updateProperty(name: string, value: any){
		this[name] = value;
	}

	@action fromJSON(data : any = {}){
		if (data) {
			_.defaults(this, data);
		}
	}

	toString(){
		return JSON.stringify(this);
	}
}



// WEBPACK FOOTER //
// ./src/stores/models/base-model.ts